export const translations = {
	en: {
		become_partner: 'Become a partner',
		blog: 'Blog',
		customer_hero_header: "Book top-rated cleaners for all your home services.",
		customer_hero_prompt: "The easiest way to book and manage Home Cleaning services in Belgium. Only 9€ / hour with the \"Titres-Services\" system (7,65€ / hour after tax-discount in the Brussels region).",
		customer_find_cleaner: "Find your cleaner now",
		choose_time: "Pick a time",
		choose_time_desc: "See all availabilities of cleaners in your neighbourhood and pick your preferred time & frequency",
		book_instantly: "Book instantly",
		book_instantly_desc: "Book a cleaner from a local 'Titres-Services' partner and get an instant confirmation.",
		follow_service: "Follow your services",
		follow_service_desc: "A professional, trained cleaner will perform the service, which you can follow and manage in the App",
		affiliate_hero_header: 'Bring your cleaning company into the digital era',
		affiliate_hero_prompt: 'Manage your schedules, bookings, customers & workers in real-time, in one simple interface',
		ask_for_affiliate_demo: 'Ask for a demo',
		see_video: 'How does Pootsy work?',
		im_a_customer: "I'm a customer",
		booking_flow_first_step_header: 'Your first step\nto a cleaner home',
		booking_flow_first_step_input_prompt: 'Enter your street and street number',
		booking_flow_second_step_header: 'Let\'s define your needs together',
		booking_flow_second_step_input_prompt: 'Don\'t panic. We help you to calculate the number of hours you need for your service',
		address_input_placeholder: 'Example: Grand Place 10, 1000 Brussels',
		next_step: 'Next',
		previous: 'Previous',
		pootsy_benefit_one: 'Pay with "Titres-Services": cheap, easy and clear',
		pootsy_benefit_two: 'Professional cleaners from vetted local business',
		pootsy_benefit_three: 'Fiscal discount with the "Titres-Services" system',
		spinner_message_checking_zip_code: 'Checking availabilities',
		why_use_pootsy: 'Why should you use pootsy ?',
		quick_n_easy: 'Quick & easy',
		quick_n_easy_desc: 'Booking your cleaner has never been so easy! Book your cleaning services in 2 minutes and get an instant confirmation. Pootsy is available 24/7.',
		affordable: 'Affordable',
		affordable_desc: 'No additional fee from us! Pootsy integrates with the "Titres-Services" vouchers system (9 € / hour). And guess what. it\'s tax-deductible ;)',
		manage_your_devices: 'Manage your services',
		manage_your_devices_desc: "Pootsy will notify you about the status of your services. But that's not all! Need a time change ? To cancel a service ? You can do that too...",
		professionals_only: 'Professionals only',
		professionals_only_desc: 'Pootsy works with a network of partners all over Belgium. They are “Titres-Services” certified, so their cleaners are vetted and trained professionals.',
		download_app: "Download the app",
		asap: "It's just a click away",
		whats_up: "What's up ?",
		service_vouchers: 'Service vouchers ("Titres-Services")',
		they_trust_us: 'They already trust us',
		keep_up: 'Stay in touch',
		keep_up_prompt: 'Be the first to know about our news and events...',
		pootsy_pro: 'Pootsy pro',
		cgu: 'Terms & conditions',
		press: 'Press',
		contact_us: 'Contact us',
		how_does_it_work: 'How does it work ?',
		how_does_it_work_desc: 'Service vouchers are subsidized by belgian regions (Brussels, Wallonia and Flanders). Anyone above 18 years of age and registered in Belgium can use them to pay for cleaning, ironing, grocery or transportation services, for a very affordable price. Using Pootsy and service vouchers, your cleaning services will only cost you 9€ / hour and are tax-deductible!',
		discover_customer_guide: 'Discover our "Service-Vouchers" guide',
		they_tested_pootsy: "They are using Pootsy:",
		more_articles: 'More articles from our blog',
		better_agency_management: 'A web interface to manage your business',
		webapp: 'For your company',
		planning_management: 'Manage your planning',
		planning_management_desc: "Dynamic & real-time management of your employees' planning and services. Let your agenda fill-up automatically, and let your staff focus on what really matters for your business.",
		follow_your_team: 'Follow your team, real-time !',
		follow_your_team_desc: "Be aware of what's happening on the field. You'll be notified if any problem occurs, and you'll be able to communicate with both your customers and cleaners.",
		accessible_everywhere: 'Always available & everywhere',
		accessible_everywhere_desc: 'Your interface is in the cloud ! That means you can connect from any computer, and access all your plannings, social secretary exports and sodexo documents, wherever you are !',
		pcla_real_time_access: "Real-time access to their planning and schedule (availabilities, holidays,...)",
		pcla_updated_statuses: "Your workers update the status of their services and report problems",
		pcla_communication_system: "Digital communication system with their company and their customers",
		pcla_auto_encode_services: "Services paid with electronic vouchers are automatically encoded",
		pcla_psv_scanner: "Paper service vouchers can be scanned right from the app",
		pcla_ios_android: "Available on both iOS and Android",
		mobile_app: "For your workers",
		help_your_employees: "A mobile App for your cleaners",
		select_employee_count: "How many cleaners work at your company ?",
		visibility: "For your customers",
		an_app_and_website_for_your_customers: "An app and a website for your customers",
		exposure_automatic_calendar_updates: "Your agenda fills up automatically when customers book their services",
		exposure_dedicated_webpage: "A webpage dedicated to your agency allows your customers to find you easily. And ensures the best search ranking.",
		exposure_customer_communication: "Stay in touch with your customers with the in-app chat",
		exposure_real_time_service_monitoring: "Real-time service monitoring",
		exposure_available_on_ios_android: "Available on both iOS and Android",
		pricing_tip: "Tip: while most of our customers choose to manage all of their workers with Pootsy to optimise their business, you can start by adding only some of them (for example, those who need to fill their planning), and upgrade later !",
		no_hidden_fees: "No hidden fees, no commitment",
		employees: 'cleaners',
		pro_summary_hr_management: "Manage your workers, their plannings, and your customers",
		pro_summary_real_time_control: "Real-time control of your workers' activity",
		pro_summary_simple_communication: "Streamlined communication between you and your customers",
		pro_summary_acquisition_channel: "New customer acquisition channel",
		pro_summary_secsoc_sodexo_integrations: "Integration with your social secretary and Sodexo",
		pro_summary_easy_to_use: "Easy to use, no installation required",
		discover_customer_app: "Discover the customer's app",
		in_summary: "In a nutshell",
		in_summary_desc: "Why should your company use Pootsy?",
		booking_flow_bedrooms: 'Bedrooms',
		booking_flow_bathrooms: 'Bathrooms',
		booking_flow_frequency: 'Frequency',
		booking_flow_frequency_once: 'Once',
		booking_flow_frequency_every_week: 'Every week',
		booking_flow_frequency_every_two_weeks: 'Every 2 weeks',
		booking_service_fridge: 'Fridge',
		booking_service_cabinets: 'Cabinets',
		booking_service_oven: 'Oven',
		booking_service_windows: 'Windows',
		booking_service_laundry: 'Laundry',
		booking_service_ironing: 'Ironing',
		booking_flow_desired_booking_services: 'Wished services',
		booking_flow_additional_options: 'Additional options',
		booking_flow_worker_language_undefined: 'I don\'t care',
		booking_flow_affiliate_undefined: 'I don\'t care',
		booking_flow_worker_undefined: 'I don\'t care',
		booking_flow_choose_worker_language: 'Worker language',
		booking_flow_choose_affiliate: 'I know a provider',
		booking_flow_choose_worker: 'I know a cleaner',
		booking_flow_i_know_a_worker: 'I know the Sodexo number of my cleaner',
		booking_flow_worker_sodexo_number_placeholder: 'Put his/her Sodexo number here',
		spinner_message_fetching_worker_languages: 'Fetching workers',
		spinner_message_fetching_affiliates: 'Fetching partners',
		spinner_message_checking_worker_sodexo_number: 'Checking worker Sodexo number',
		error_wrong_worker_sodexo_number: 'This Sodexo number doesn\'t belongs to any cleaner',
		booking_flow_choose_affiliate_info: 'You already know a Service Provider and you want to work with them? No problem, here is the list of providers available in your area. Pick your favorite one!',
		booking_flow_choose_worker_info: 'You know a cleaner and you want to keep on working with him/her? No problem, ask him/her his/her Sodexo number and you will see his/her availabilities!',
		booking_flow_i_know_a_worker_info: 'You wish to work with a cleaner you have already worked with? Choose him/her in the list below',
		booking_flow_third_step_header: 'Pick the day and time\nof your first service',
		booking_flow_date_selection_title_first_part: 'Your service will last',
		booking_flow_date_selection_title_second_part: 'and will take place',
		booking_flow_date_selection_subtitle: 'Your booking will be paid by {voucher_count} "titres-services" for each occurence',
		common_hours: 'hours',
		booking_flow_date_selection_worker_label: 'Your cleaner will be {worker_name}',
		time_slot_seeker_choose_hour: 'Choose your favorite time for your service',
		booking_flow_date_selection_choose_another_worker: 'Choose another cleaner',
		booking_flow_date_selection_worker_selection_title: 'Pick a cleaner from one of our partners',
		booking_flow_date_selection_worker_selection_sub_title: 'All our partners are Sodexo-certified and their cleaners are professional',
		booking_flow_date_selection_worker_selection_recommended: 'Recommended by Pootsy',
		booking_flow_date_selection_worker_selection_select: 'Choose me!',
		booking_flow_date_selection_worker_selection_selected: 'Selected',
		booking_flow_residence_selection_title: 'Where will the service\ntake place',
		booking_flow_residence_selection_new_residence_title: 'Add a new address ?',
		booking_flow_residence_selection_use_address: 'Use this address',
		booking_flow_housing_type: 'Home type',
		common_housing_type_house: 'House',
		common_housing_type_apartment: 'Apartment',
		common_housing_type_other: 'Other',
		common_street_name: 'Street',
		common_street_number: 'Number',
		common_zip_code: 'Postal code',
		common_city: 'City',
		common_surface: 'Surface',
		common_other_info: 'Other info',
		common_how_to_get_in: 'How to get in?',
		bookings: 'Services',
		date: "Date",
		time: "Time",
		recurrence: "Frequency",
		common_m2: 'm²',
		common_i_have_a_pet: 'I have a pet',
		advantages: "Benefits",
		testimony2: "\"We found Kamila thanks to Pootsy. She works for a Titres-Services Company very close to our home. We could immediately trust her and she comes every week now!\"",
		testimony1: "\"It was sometimes very difficult to contact the Titres-Services company of my previous cleaners. With Pootsy, I can send them messages directly and they help us if there is a problem!\"",
		testimony4: "\"It's convenient for us to receive status updates about our services. And we never miss a message from my cleaner! She sends us picture of empty cleaning products we have to buy for the next service. It's very useful!\"",
		testimony3: "\"I like new technologies, so I was pleased to be able to book a service in less than 2 minutes with my phone. I didn't know the Titres-Services system, but Pootsy took care of the subscription. Very easy!\"",
		testimony2_name: "Martine",
		testimony2_location: "Uccle",
		testimony1_name: "Maximilien",
		testimony1_location: "Antwerpen",
		testimony3_name: "Alexandra",
		testimony3_location: "Waterloo",
		testimony4_name: "Sarah & Tom",
		testimony4_location: "Brussels",
		testimonies: "Testimonials",
		price_per_month: ".99€ / month",
		always_accessible: "A web interface to manage your business",
		always_accessible_desc: "Easily manage your plannings, download reports & official documents, and communicate with your workers and customers.",
		easy_to_use: "A mobile App & a website for your customers",
		easy_to_use_desc: "Your customers receive updates about their services, instantly book your cleaners and easily communicate with you and your cleaners",
		communication_tool: "A mobile App for your cleaners",
		communication_tool_desc: "Your cleaners receive their planning in real-time, they provide feedback about their services and they request their holidays",
		login: "Sign in",
		my_affiliate: "My provider",
		my_affiliates: "My providers",
		my_account: "My account",
		my_services: "My services",
		future_bookings: "To come",
		past_bookings: "Past",
		to: "to",
		from: "from",
		assigned: "Assigned",
		finished: "Finished",
		finished_without_confirmation: "Finished",
		ongoing: "Ongoing",
		cancelled: "Cancelled",
		problem: "Problem",
		not_delivered: "Not delivered",
		address: "Address",
		service_for_date: "Service on",
		problem_with_service_prompt: "Do you have a problem with your service or your cleaner ?",
		feel_like_leaving_a_message: "Leave here a message for your cleaner about this service",
		what_did_you_think_of_last_service: "What did you think of your last service ?",
		share_on_facebook: "Share on Facebook",
		share_on_twitter: "Share on Twitter",
		share_with_email: "Share by e-mail",
		new_booking: "New booking",
		do_you_like_pootsy: "Do you like Pootsy ?",
		share_pootsy_with_friends: "Share Pootsy with your friends",
		once: "Once",
		every_week: "Every week",
		every_two_weeks: "Every two weeks",
		review_modal_title: "What did you think of your last service ?",
		leave_a_message_optional: "Leave a message to your cleaner (optional)",
		continue: "Continue",
		cancel: "Cancel",
		what_did_you_think_of_this_service: "What did you think of this service ?",
		service_happened_at_date: "Service took place on",
		service_delivered_by: "with",
		show_more: '+ Show more services',
		twitter_sharing_message: "Need some help at home with your daily chores? Discover Pootsy at https://www.pootsy.be !",
		mail_sharing_message: "Need some help at home with your daily chores? Discover Pootsy at https://www.pootsy.be !",
		login_header: "Welcome to Pootsy",
		create_account_prompt: "No account yet?",
		create_account: "Click here to create yours",
		email_input_label: "Enter your e-mail",
		email_input_placeholder: "ex: jean.michel@pootsy.be",
		forgot_password: "Forgot password?",
		password_input_label: "Enter your password",
		password_input_placeholder: "ex: *******",
		remember_me: "Remember me",
		residence_type: 'Home type',
		surface: 'Surface',
		pets: "Pets",
		yes: "Yes",
		no: "No",
		house: 'House',
		apartment: 'Apartment',
		type_other: 'Other',
		profile: "My profile",
		addresses: "My addresses",
		notifications: "My notifications",
		security: "My security",
		account_profile_prompt: "Personal information",
		gender: "Gender",
		gender_mr: "Mr",
		gender_mrs: "Mrs",
		first_name_input_label: "First name",
		last_name_input_label: "Last name",
		language: "Language",
		language_fr: "Français",
		language_nl: "Nederlands",
		language_en: "English",
		account_profile_contact_prompt: "Contact information",
		telephone_input_label: "Mobile phone number",
		secondary_phone_input_label: "Secondary phone number",
		landline_phone_input_label: "Landline phone number",
		account_profile_sodexo_prompt: "Sodexo information",
		sodexo_reference_input_label: "Your Sodexo number",
		sodexo_region: "Your Sodexo region",
		sodexo_region_bxl: "Brussels",
		sodexo_region_vl: "Flanders",
		sodexo_region_wal: "Wallonia",
		save: "Save",
		terms_of_service: "Terms of service",
		ask_for_demo_mail_subject: "I would like a a demo of Pootsy",
		ask_for_demo_mail_content: "Hello,\n I would like a demo of Pootsy Pro to discover all the benefits it may have for my Titres-Services/Dienstencheques company.\n Here are my contact details:\n",
		dismiss_error_modal: "OK",
		error_modal_title: "Error",
		booking_flow_sodexo_title: 'Are you already registered to the Sodexo Service Vouchers system?',
		booking_flow_sodexo_input_prompt: 'Pootsy is a free service to manage your Home Cleaning service with the Titres-Services/Dienstencheques system.\n These are available for any person whose residence is in Belgium',
		booking_flow_sodexo_voucher_count_label: 'Your booking requires {voucher_count} titres-services/dienstencheques for each occurence',
		booking_flow_sodexo_voucher_type_title: 'What kind of Titres-Services/Dienstencheques would you like to use?',
		booking_flow_sodexo_voucher_type_subtitle: 'Save the planet, use electronic Vouchers :)',
		booking_flow_sodexo_voucher_type_electronic: 'Electronic Vouchers',
		booking_flow_sodexo_voucher_type_paper: 'Paper Vouchers',
		booking_flow_sodexo_region_title: 'In which Region is your official domicile located?',
		booking_flow_sodexo_region_subtitle: 'It must be your official domicile, the one on your ID (not necessarily where the service will take place)',
		sodexo_region_brussels: 'Brussels',
		sodexo_region_flanders: 'Flanders',
		sodexo_region_wallonia: 'Wallonia',
		booking_flow_sodexo_number_title: 'What is your Sodexo number?',
		booking_flow_sodexo_number_subtitle: 'This number is made of 12 digits. You can find it on your Sodexo account.',
		booking_flow_sodexo_number_placeholder: 'Ex: 9700000012345',
		booking_flow_sodexo_explainer_title: 'No worry! Pootsy can take care of your subscription with a few additional questions!',
		booking_flow_sodexo_explainer_subtitle: 'Do you know that the Service Vouchers are an attractive mean of payment for your Home Cleaning services? They are tax-deductible and give you access to vetted cleaner in a large network of local providers for a transparent price of 9€ / hour.',
		booking_flow_sodexo_explainer_subtitle_link: 'Discover more about Service Vouchers',
		booking_flow_sodexo_niss_title: 'What is your national register number?',
		booking_flow_sodexo_niss_subtitle: 'This number is made of 11 digits. You can find it at the back of your ID card',
		booking_flow_sodexo_niss_placeholder: 'ex: 86.02.18-134.05',
		booking_flow_sodexo_residence_title: 'What is the address of your offical domicile ?',
		booking_flow_sodexo_residence_subtitle: 'It must be the address of your official domicile, the one on your ID (not necessarily where the service will take place)',
		booking_flow_sodexo_residence_choose_new: 'Choose a new address',
		booking_flow_sodexo_residence_new_modal_title: 'Add a new address',
		booking_flow_sodexo_iban_title: 'What is your bank account number ?',
		booking_flow_sodexo_iban_subtitle: 'Sodexo needs your IBAN account number in case of refunds. This information won\'t be stored or used by Pootsy and/or our partners',
		booking_flow_sodexo_terms_label: 'I will respect the conditions of the user of Service Vouchers system (Royal Decree of 12/12/2001)',
		booking_flow_confirmation_title: 'Summary',
		booking_flow_confirmation_date: 'Date',
		booking_flow_confirmation_time_slot: 'Time',
		booking_flow_confirmation_time_slot_value: 'From {start}h to {end}h ({duration} hours)',
		booking_flow_confirmation_frequency: 'Frequency',
		booking_flow_confirmation_price: 'Price',
		booking_flow_confirmation_price_value: '{price}€ ({voucher_count} titres-services/dienstencheques)',
		booking_flow_confirmation_voucher_type: 'Vouchers type',
		booking_flow_confirmation_address: 'Address of the service',
		booking_confirmation_convention_title: 'Your Provider will be',
		booking_confirmation_convention_decription: 'This partner provides high-quality services which are wrapped up in their "Customer Agreement"',
		booking_confirmation_download_convention: 'Customer agreement',
		accept_cgu: 'I agree with Pootsy Terms & Conditions',
		accept_convention: 'I agree with the Customer agreement of the Provider',
		manage_your_booking_with_the_app: "Manage your booking with the Pootsy App",
		manage_your_booking_with_the_app_desc: "With the Pootsy App, you can manage your Home Cleaning Services in a 100% securised environment: communicate with your cleaner, change your dates, rate a service, get notifications,… Available on iOS and Android.",
		affiliate_page_bio: "Lorem ipsum dolor sit amet, postea fierent et pri, vel integre corrumpit intellegebat ut. Enim expetenda eloquentiam ut eum. Sed ad partem ocurreret conclusionemque, ad eripuit omittam mei. Erant laboramus eos in. Duo dicat omnes ut, an aeque discere duo. Vis in agam salutandi molestiae, probatus persequeris ea pri, usu dicam diceret intellegam ne. Sonet necessitatibus te eam.",
		book_your_service_button: "Book a service",
		phone: "Phone",
		email: "E-mail",
		time_slot_label_top_rating: 'Top-rated cleaner!',
		time_slot_label_top_affiliate_rating: 'Top-rated provider!',
		time_slot_label_neighbourhood: 'Live in your neighbourhood',
		time_slot_label_recent_booking: 'Recently booked',
		time_slot_label_friend: 'Recommended by a friend',
		time_slot_label_language: 'Speaks your language',
		signup_prompt: "Already a member?",
		sign_in: "Click here to sign-in",
		passwords_dont_match: "Your password don't match",
		password_confirmation_input_placeholder: "\"ex: *******\"",
		accept_emails: "Yes, send me the Pootsy newsletter to receive discounts, tips and updates",
		logout: "Log out",
		website_title: 'Pootsy - Book top-rated cleaners for all your home services',
		email_placeholder: 'Ex: jean.michel@pootsy.be',
		signup_header: 'Welcome to Pootsy',
		delete_residence_title: "Delete this address?",
		old_password_input_label: "Old password",
		new_password_input_label: "New password",
		new_password_confirmation_input_label: "Confirm new password",
		common_confirm: "Confirm",
		affiliate_chat_prompt: "Leave here a message for your Provider (ex: an issue with your cleaner, etc...)",
		welcome: "Welcome",
		needs: "Needs",
		availabilities: "Availabilities",
		informations: "Information",
		confirmation: "Confirmation",
		signin_header: "Connect to your account",
		signin_prompt: "Not an account yet?",
		booking_flow_sign_up: "Click here to create your account",
		booking_flow_sign_in: "Click here to sign in",
		signup_explanation_prompt: "Thanks to Pootsy, you can:",
		booking_flow_needs_estimation_title: "Estimated number of hours that you need:",
		booking_flow_needs_estimation_description: "Don't worry, you can choose the final number of hours on the next screen",
		discover_pootsy: "Discover Pootsy",
		common_street_box: "Box",
		service_vouchers_guide_url: "https://pootsy.be/3770/service-vouchers-how-does-it-work/?lang=en",
		enter_zip_code_not_covered_modal_title: "Oops",
		enter_zip_code_not_covered_modal_description: "This city is not yet served. Do you want to be notified when it is available? Leave us your e-mail address to be the first to know!",
		send: "Send",
		video_url: "https://www.youtube.com/embed/QZM1aNYUH0Q?cc_load_policy=1&cc_lang_pref=en",
		signup: "Create my account",
		'service_delivery.assigned_event_title': 'The service is assigned',
   	 	'service_delivery.cancelled_event_title':'The service is cancelled',
    	'service_delivery.ongoing_event_title': 'The service has started',
    	'service_delivery.finished_event_title': 'The service is finished',
    	'service_delivery.problem_event_title': 'A problem occured during the service',
    	'service_delivery.not_delivered_event_title': 'The service could not be delivered',
    	'service_delivery.review_event_title': 'Feedback on the service',
    	'service_delivery.message_event_title': 'Message',
    	'forgot_password_prompt': 'Forgotten or lost password? Give us your e-mail address and we will send you instructions to reset it.',
    	'send_recovery_email_button': 'Send',
    	'closed': 'Closed',
    	'itinerary': 'Itinerary',
    	"download_app_prompt": "To have a better experience, please download the Pootsy Mobile App, available on iOS and Android",
    	"click_here_to_download_app": "Click here to download the App",
		meta_description: "Pootsy is the easiest way to book home cleaning service at home with Service Vouchers ( Titres-Services / Dienstencheques )",
		website: "Website",
		tss_empty_modal_title: "Oops",
		tss_empty_modal_description: "We don't have any availabilities anymore in this area. Do you want to be notified when it is available? Leave us your e-mail address to be the first to know!",
		review_rating_message: 'Rating',
		pootsy_covers_area_desc: "Discover our network of official Service Vouchers companies (all affiliated to Sodexo). Their cleaners are all professional workers who are regularly trained to deliver the best cleaning experience. With Pootsy, you can check their availabilties instantly!",
		pootsy_does_not_cover_area_desc: "Give us your e-mail address (don't worry, we won't use it for anything), and we'll notify you as soon as Pootsy is present in your area",
		find_my_cleaner_in_area: "Find a cleaner in",
		more_about_pootsy: "More about Pootsy",
		more_about_service_vouchers: "More about Service Vouchers",
		pootsy_covers_area_at: "Pootsy is available at",
		pootsy_does_not_cover_area_at: "Oh no! Pootsy is not yet in",
		discover_our_partners_in: "Discover our partners in",
		see_our_availabilities: "See our availabilties",
		thank_you_email_sent_flash: "E-mail sent, thank you!",
		rated: "Rated {note} / {total} based on {total_formatted} reviews.",
		affiliate_meta_description: 'Book your cleaner at {affiliateName} in 5 steps !',
		zip_code_mode_page_title: 'Cleaners from you neighbourhood in {area} {zoneName}',
		zip_code_mode_meta_description: 'Need help to clean your home in {area} {zoneName} ? Trust our cleaners from certified Service Vouchers (Titres-Services / Dienstencheques) partners.',
		privacy_action_remove_affiliate_data_title: 'Delete provider contract and remove all my data',
		privacy_action_ask_affiliate_data_description: 'This action will send a message to your service provider to let them know that you want to end your contractual relationship and remove all your data according to their data protection policy. You will receive a confirmation from your service provider',
		privacy_action_ask_affiliate_data_button_title: 'Delete my contract',
		privacy_action_remove_pootsy_data_title: 'Delete Pootsy account',
		privacy_action_remove_pootsy_data_description: 'This action will delete your Pootsy account and remove all related personal data within 24 hours.',
		privacy_action_remove_pootsy_data_button_title: 'Delete my Pootsy account',
		privacy_action_end_contract_title: 'End provider contract',
		privacy_action_end_contract_description: 'This action will end your current contract with your service provider at the earliest date.',
		privacy_action_end_contract_button_title: 'End my provider contract',
		privacy_action_export_affiliate_data_title: 'Export data from my provider',
		privacy_action_ask_export_affiliate_data_description: 'Your service provider collects some data about you within the framework of your contract. You can export this data for your reference or to transport them to another tool',
		privacy_action_ask_export_affiliate_data_button_title: 'Export my data',
		privacy_action_export_pootsy_data_title: 'Export my Pootsy data',
		privacy_action_export_pootsy_data_description: 'Pootsy collects some data to make this App works. You can export this data for your reference or to transport them to another tool.',
		privacy_action_export_pootsy_data_button_title: 'Export my data',
		execute_privacy_action_confirmation_title: 'Confirmation',
		account_privacy_terms_title: 'Read our',
		privacy_terms_description: 'Privacy Policy',
		cookie_banner_text: 'We use cookies to personalise content, to provide social media features and to analyse our traffic. You consent to our cookies if you continue to use our website. Please read our Privacy Policy for more information.',
		accept_cookie_policy_button: 'OK',
		cookie_policy_information_button: 'Read Privacy Policy',
		commercial_pootsy_email:'by e-mail',
		commercial_pootsy_push:'by notifications',
		affiliate_commercial_notifications_description:'Do you agree to receive commercial information from your cleaning provider?',
		communication_email:'by e-mail',
		communication_push:'by notifications',
		pootsy_commercial_notifications_description: 'How do you prefer to receive promotions, discounts, tips and other information from Pootsy ?',
		communication_notifications_description: 'How do you want to receive messages from your cleaner or your cleaning provider ?',
		click_here:'Click here',
		account_privacy_notifications_title: 'My notifications',
		privacy: 'My privacy',
		commercial_affiliate: "Yes, I agree",
	},
	fr: {
		become_partner: 'Devenir partenaire',
		blog: 'Blog',
		customer_hero_header: "Trouvez une aide-ménagère pour toutes vos tâches à domicile.",
		customer_hero_prompt: "Le chemin le plus facile pour trouver et gérer vos prestations d'aides-ménagères à domicile en Belgique. Seulement 9€/h avec les Titres-Services (après réduction d'impôt: 7,65€/h en région Bruxelloise et 8,10€/h en région Wallonne).",
		customer_find_cleaner: "Trouver mon aide-ménagère",
		choose_time: "Choisissez un créneau horaire",
		choose_time_desc: "Voyez directement toutes les disponibilités des aides-ménagères proches de chez vous et choisissez votre créneau horaire préféré.",
		book_instantly: "Réservation instantanée",
		book_instantly_desc: "Réserver une prestation avec une aide-ménagère d'une agence Titres-Services de votre quartier et recevez une confirmation immédiate.",
		follow_service: "Suivez vos prestations",
		follow_service_desc: "Une aide-ménagère professionnelle effectuera la prestation, que vous pourrez suivre et gérer directement dans l'App.",
		affiliate_hero_header: 'Faîtes entrer votre société de Titres-Services dans l\'ère du digital',
		affiliate_hero_prompt: 'Gérez vos plannings, vos réservations, vos clients et vos travailleurs en temps-réel, une interface simple.',
		ask_for_affiliate_demo: 'Demander une démo',
		see_video: 'Comment ça fonctionne?',
		im_a_customer: "Je suis un client",
		booking_flow_first_step_header: 'Votre première étape\nvers une maison plus propre',
		booking_flow_first_step_input_prompt: 'Entrez votre rue et numéro de rue',
		booking_flow_second_step_header: 'Définissons ensemble votre besoin',
		booking_flow_second_step_input_prompt: 'Pas de panique! Nous vous aidons à calculer le nombre d\'heures d\'aide-ménagère dont vous avez besoin',
		address_input_placeholder: 'Exemple: Grand Place 10, 1000 Bruxelles',
		next_step: 'Suivant',
		previous: 'Précédent',
		pootsy_benefit_one: 'Payez avec les Titres-Services: bon marché, facile et transparent',
		pootsy_benefit_two: 'Des aides-ménagères professionnelles auprès de sociétés de Titres-Services proches de chez vous',
		pootsy_benefit_three: 'Réduction fiscale avec le système des Titres-Services',
		spinner_message_checking_zip_code: 'Calcul des disponibilités',
		why_use_pootsy: 'Pourquoi utiliser Pootsy ?',
		quick_n_easy: 'Facile & rapide',
		quick_n_easy_desc: 'Réserver une prestation d\'aide ménagère n\'a jamais été aussi facile! Réserver une prestation en moins de 2 minutes, avec confirmation immédiate. Dispo 7 jours sur 7.',
		affordable: 'Abordable',
		affordable_desc: 'Pas de frais cachés avec nous! Pootsy intègre le système des Titres-Services (9€/h). Et devinez quoi? C\'est déductible de vos impôts ;-)',
		manage_your_devices: 'Gérez vos prestations',
		manage_your_devices_desc: "Pootsy vous enverra des notifications sur le statut de vos prestations. Mais ce n'est pas tout! Besoin de modifier un horaire? D'annuler une prestation? Vous pouvez également le faire avec Pootsy...",
		professionals_only: 'Uniquement des professionels',
		professionals_only_desc: 'Pootsy travaille avec un réseau de Partenaires partout en Belgique. Il s\'agit exclusivement de sociétés agréées Titres-Services. Leurs aides-ménagères sont donc des professionnels approuvés et formés.',
		download_app: "Télécharger l'App",
		asap: "C'est à portée de clic...",
		whats_up: "Quoi de neuf?",
		service_vouchers: 'Titres-Services',
		they_trust_us: 'Ils nous font déjà confiance',
		keep_up: 'Restons en contact',
		keep_up_prompt: 'Soyons les premiers avertis de nos évènements, nouveautés,...',
		pootsy_pro: 'Pootsy pro',
		cgu: 'Conditions générales',
		press: 'Presse',
		contact_us: 'Contactez nous',
		how_does_it_work: 'Comment ça marche ?',
		how_does_it_work_desc: 'Les Titres-Services sont subsidiés par les Régions belges (Bruxelles, Wallonie, Flandres). Toute personne majeure résidant en Belgique peut les utiliser pour payer des prestations de nettoyage repassage, petites courses et transport de personnes handicapées. En utilisant Pootsy et les Titres-Services, vos prestations coûtent 9€ / heure et sont déductibles de vos impôts.',
		discover_customer_guide: 'Découvrez notre "Guide Titres-Services"',
		they_tested_pootsy: "Ils ont testé Pootsy:",
		more_articles: 'Plus d\'articles de notre blog',
		better_agency_management: 'Une interface web pour gérer votre société',
		webapp: 'Pour votre société',
		planning_management: 'Gérez vos plannings',
		planning_management_desc: "Gestion dynamique et en temps-réel des plannings de vos travailleurs et de vos prestations. Laissez votre planning se remplir tout seul et permettez à vos employés de se concentrer sur ce qui est vraiment important pour votre société.",
		follow_your_team: 'Suivez votre équipe en temps-réel!',
		follow_your_team_desc: "Soyez au courant de ce qui se passe sur le terrain. Vous serez prévenu si un problème survient, et vous pourrez communiquer facilement avec votre travailleur et votre client.",
		accessible_everywhere: 'Toujours et partout disponible',
		accessible_everywhere_desc: 'Votre interface est dans le Cloud! Cela signifie que vous pouvez vous y connecter depuis n\'importe quel ordinateur, et accéder à vos plannings, vos exports de secrétariat social et vos documents Sodexo où que vous soyez!',
		pcla_real_time_access: "Accès en temps-réel à leur planning et horaire (disponibilités, congé,...)",
		pcla_updated_statuses: "Vos travailleurs mettent à jour le statut de leurs prestations et rapportent les problèmes éventuels.",
		pcla_communication_system: "Système de communication digital avec leur société et leurs clients",
		pcla_auto_encode_services: "Les prestations payées avec des Titres-Services électroniques sont automatiquement encodés",
		pcla_psv_scanner: "Les Titres-Services papiers sont scannés directement dans l'App",
		pcla_ios_android: "Disponible sur iOS et Android",
		mobile_app: "Pour vos travailleurs",
		help_your_employees: "Une App mobile pour vos travailleurs",
		select_employee_count: "Combien d'aides-ménagères travaillent pour vous ?",
		visibility: "Pour vos clients",
		an_app_and_website_for_your_customers: "Une App et un site web pour vos clients",
		exposure_automatic_calendar_updates: "Votre planning se remplit automatiquement quand vos (nouveaux) clients réservent leurs prestations",
		exposure_dedicated_webpage: "Une page web dédiée à votre agence permet à vos clients de vous trouver facilement et vous donne les meilleurs résultats dans les moteurs de recherche.",
		exposure_customer_communication: "Restez en contact avec vos clients grâce à un chat dans l'Application",
		exposure_real_time_service_monitoring: "Contrôle en temps-réel",
		exposure_available_on_ios_android: "Disponible sur iOS et Android",
		pricing_tip: "Conseil: Bien que la plupart de nos clients décident de gérer tous les travailleurs dans Pootsy pour optimiser leur société, vous pouvez commencer avec seulement une partie (par exemple, ceux qui ont des plannings incomplets). Vous pourrez upgrader plus tard!",
		no_hidden_fees: "Pas de frais cachés, pas d'engagement!",
		employees: 'travailleurs',
		pro_summary_hr_management: "Gérez vos travailleurs, vos plannings et vos clients",
		pro_summary_real_time_control: "Contrôle en temps réel de l'activité de vos travailleurs",
		pro_summary_simple_communication: "Communication simplifiée entre vous et vos clients",
		pro_summary_acquisition_channel: "Nouveau canal d'acquisition de clients",
		pro_summary_secsoc_sodexo_integrations: "Intégration avec votre Secrétariat Social et Sodexo",
		pro_summary_easy_to_use: "Facile à utiliser, pas d'installation requise",
		discover_customer_app: "Découvrez l'App pour vos clients",
		in_summary: "En résumé",
		in_summary_desc: "Pourquoi Pootsy va aider votre société",
		booking_flow_bedrooms: 'Chambres',
		booking_flow_bathrooms: 'Salles de bain',
		booking_flow_frequency: 'Fréquence',
		booking_flow_frequency_once: 'Une fois',
		booking_flow_frequency_every_week: 'Toutes les semaines',
		booking_flow_frequency_every_two_weeks: 'Toutes les 2 semaines',
		booking_service_fridge: 'Frigo',
		booking_service_cabinets: 'Placards',
		booking_service_oven: 'Four',
		booking_service_windows: 'Fenêtres',
		booking_service_laundry: 'Lessive',
		booking_service_ironing: 'Repassage',
		booking_flow_desired_booking_services: 'Services souhaités',
		booking_flow_additional_options: 'Options supplémentaires',
		booking_flow_worker_language_undefined: 'Pas de préférence',
		booking_flow_affiliate_undefined: 'Pas de préférence',
		booking_flow_worker_undefined: 'Pas de préférence',
		booking_flow_choose_worker_language: 'Langue de l\'aide-ménagère',
		booking_flow_choose_affiliate: 'Je connais une société Titres-Services',
		booking_flow_choose_worker: 'Je connais une aide-ménagère',
		booking_flow_i_know_a_worker: 'Je connais le numéro Sodexo de mon aide-ménagère',
		booking_flow_worker_sodexo_number_placeholder: 'Entrez ici son numéro Sodexo',
		spinner_message_fetching_worker_languages: 'Recherche des travailleurs',
		spinner_message_fetching_affiliates: 'Recherche des partenaires',
		spinner_message_checking_worker_sodexo_number: 'Vérification du numéro Sodexo',
		error_wrong_worker_sodexo_number: 'Ce numéro Sodexo n\'est pas attribué à un travailleur',
		booking_flow_choose_affiliate_info: 'Vous connaissez déjà une société Titres-Services et vous souhaitez travailler avec elle? Pas de problème, voici la liste de nos partenaires dans votre quartier. Choisissez votre préféré!',
		booking_flow_choose_worker_info: 'Vous connaissez une aide-ménagère and vous souhaitez continuer à travailler avec elle? Pas de problème, demandez-lui son numéro Sodexo et vous pourrez voir ses disponibilités!',
		booking_flow_i_know_a_worker_info: 'Vous souhaitez voir les disponibilités d\'un travailleur avec qui vous avez déjà travaillé? Retrouvez les dans la liste ci-dessous.',
		booking_flow_third_step_header: 'Choisissez le créneau horaire\nde votre prestation',
		booking_flow_date_selection_title_first_part: 'Votre prestation durera',
		booking_flow_date_selection_title_second_part: 'et aura lieu à',
		booking_flow_date_selection_subtitle: 'Votre réservation sera payée par {voucher_count} titres-services pour chaque prestation',
		common_hours: 'heures',
		booking_flow_date_selection_worker_label: 'Votre aide-ménagère sera {worker_name}',
		time_slot_seeker_choose_hour: 'Choisissez votre créneau horaire préféré',
		booking_flow_date_selection_choose_another_worker: 'Choisir une autre aide-ménagère',
		booking_flow_date_selection_worker_selection_title: 'Choissisez une aide-ménagère chez un de nos partenaires',
		booking_flow_date_selection_worker_selection_sub_title: 'Tous nos partenaires sont certifiés par Sodexo et leurs travailleurs sont des Professionnels.',
		booking_flow_date_selection_worker_selection_recommended: 'Recommandé par Pootsy',
		booking_flow_date_selection_worker_selection_select: 'Choisissez-moi!',
		booking_flow_date_selection_worker_selection_selected: 'Sélectionné',
		booking_flow_residence_selection_title: 'Où aura lieu\nla prestation',
		booking_flow_residence_selection_new_residence_title: 'Ajouter une nouvelle adresse?',
		booking_flow_residence_selection_use_address: 'Utiliser cette adresse',
		booking_flow_housing_type: 'Type d\'habitation',
		common_housing_type_house: 'Maison',
		common_housing_type_apartment: 'Appartement',
		common_housing_type_other: 'Autre',
		common_street_name: 'Rue',
		common_street_number: 'Numéro',
		common_zip_code: 'Code postal',
		common_city: 'Ville',
		common_surface: 'Surface',
		common_other_info: 'Autre infos',
		common_how_to_get_in: 'Comment entrer ?',
		bookings: 'Prestations',
		date: "Date",
		time: "Heure",
		recurrence: "Fréquence",
		common_m2: 'm²',
		common_i_have_a_pet: 'J\'ai un animal de compagnie',
		advantages: "Avantages",
		testimony2: "\"Nous avons trouvé Kamila grâce à Pootsy. Elle travaille pour une société Titres-Services près de chez nous. Nous lui avons directement fait confiance et elle vient maintenant toutes les semaines!\"",
		testimony1: "\"C'était parfois difficile d'entrer en contact avec la société Titres-Services de mes précédentes aides-ménagères. Avec Pootsy, je peux leur envoyer des messages directement pour recevoir de l'aide si besoin.\"",
		testimony4: "\"C'est vraiment pratique d'être prévenu de la fin d'une de nos prestations. Et nous ne manquons plus un seul message de notre aide-ménagère! Elle nous envoie des photos des produits vides que nous devons racheter pour la prochaine fois. Pratique!\"",
		testimony3: "\"J'aime les nouvelles technologies, et j'étais donc ravi de pouvoir réserver une prestation en moins de 2 minutes sur mon smartphone. Je ne connaissais pas les Titres-Services, mais Pootsy s'est chargé de mon inscription. Très facile!\"",
		testimony2_name: "Martine",
		testimony2_location: "Uccle",
		testimony1_name: "Maximilien",
		testimony1_location: "Anvers",
		testimony3_name: "Alexandra",
		testimony3_location: "Waterloo",
		testimony4_name: "Sarah & Tom",
		testimony4_location: "Bruxelles",
		testimonies: "Témoignages",
		price_per_month: ".99€ / mois",
		always_accessible: "Une interface web pour gérer votre société",
		always_accessible_desc: "Gérez facilement vos plannings, téléchargez vos rapports & documents officiels, et communiquez avec vos travailleurs et clients.",
		easy_to_use: "Une App Mobile et un site web pour vos clients",
		easy_to_use_desc: "Vos clients reçoivent des notifications sur le statut de leurs prestations, réservent automatiquement des prestations avec vos travailleurs et communiquent facilment avec vous et leur aide-ménagère",
		communication_tool: "Une App mobile pour vos travailleurs",
		communication_tool_desc: "Vos travailleurs reçoivent leur planning en temps-réel, donnent du feedback sur leurs prestations et font leurs demandes de congé",
		login: "Se connecter",
		my_affiliate: "Mon prestataire",
		my_affiliates: "Mes prestataires",
		my_account: "Mon compte",
		my_services: "Mes prestations",
		future_bookings: "A venir",
		past_bookings: "Passées",
		to: "à",
		from: "de",
		assigned: "Planifié",
		finished: "Terminée",
		finished_without_confirmation: "Terminée",
		ongoing: "En cours",
		cancelled: "Annulée",
		problem: "Problème",
		not_delivered: "Non effectuée",
		address: "Adresse",
		service_for_date: "Prestation le",
		problem_with_service_prompt: "Vous avez un problème avec votre prestation ou votre aide-ménagère?",
		feel_like_leaving_a_message: "Laissez ici un message pour votre aide-ménagère au sujet de cette prestation",
		what_did_you_think_of_last_service: "Qu'avez-vous pensé de votre dernière prestation?",
		share_on_facebook: "Partager sur Facebook",
		share_on_twitter: "Partager sur Twitter",
		share_with_email: "Partager par e-mail",
		new_booking: "Nouvelle réservation",
		do_you_like_pootsy: "Vous aimez Pootsy?",
		share_pootsy_with_friends: "Partagez Pootsy avec vos amis!",
		once: "Une fois",
		every_week: "Toutes les semaines",
		every_two_weeks: "Toutes les 2 semaines",
		review_modal_title: "Qu'avez-vous pensé de votre dernière prestation?",
		leave_a_message_optional: "Laissez un message à votre aide-ménagère (optionel)",
		continue: "Continuer",
		cancel: "Annuler",
		what_did_you_think_of_this_service: "Qu'avez-vous pensé de cette prestation?",
		service_happened_at_date: "La prestation a eu lieu le",
		service_delivered_by: "avec",
		show_more: '+ voir plus de prestations',
		twitter_sharing_message: "Besoin d'aide à la maison avec vos tâches ménagères? Découvrez Pootsy sur https://www.pootsy.be !",
		mail_sharing_message: "Besoin d'aide à la maison avec vos tâches ménagères? Découvrez Pootsy sur https://www.pootsy.be !",
		login_header: "Bienvenue chez Pootsy",
		create_account_prompt: "Pas encore membre?",
		create_account: "Cliquez ici pour créer un compte",
		email_input_label: "Entrez votre e-mail",
		email_input_placeholder: "ex: jean.michel@pootsy.be",
		forgot_password: "Mot de passe oublié?",
		password_input_label: "Entrez votre mot de passe",
		password_input_placeholder: "ex: *******",
		remember_me: "Se souvenir de moi",
		residence_type: 'Type d\'habitation',
		surface: 'Surface',
		pets: "Animaux de compagnie",
		yes: "Oui",
		no: "Non",
		house: 'Maison',
		apartment: 'Appartement',
		type_other: 'Autre',
		profile: "Mon profil",
		addresses: "Mes adresses",
		notifications: "Mes notifications",
		security: "Ma sécurité",
		account_profile_prompt: "Informations personnelles",
		gender: "Civilité",
		gender_mr: "M",
		gender_mrs: "Mme",
		first_name_input_label: "Prénom",
		last_name_input_label: "Nom",
		language: "Langue",
		language_fr: "Français",
		language_nl: "Nederlands",
		language_en: "English",
		account_profile_contact_prompt: "Information de contact",
		telephone_input_label: "Numéro de GSM",
		secondary_phone_input_label: "Deuxième numéro",
		landline_phone_input_label: "Numéro téléphone fixe",
		account_profile_sodexo_prompt: "Informations Sodexo",
		sodexo_reference_input_label: "Votre numéro Sodexo",
		sodexo_region: "Votre région Sodexo",
		sodexo_region_bxl: "Bruxelles",
		sodexo_region_vl: "Flandres",
		sodexo_region_wal: "Wallonie",
		save: "Enregistrer",
		terms_of_service: "Conditions générales",
		ask_for_demo_mail_subject: "Je souhaiterais avoir une démo de Pootsy Pro",
		ask_for_demo_mail_content: "Bonjour,\n Je souhaiterais avoir une démo de Pootsy Pro pour en découvrir tous les avantages potentiels pour ma société de Titres-Services.\n Voici les informations pour me contacter: \n",
		dismiss_error_modal: "OK",
		error_modal_title: "Erreur",
		booking_flow_sodexo_title: 'Êtes-vous déjà inscrit au système des Titres-Services?',
		booking_flow_sodexo_input_prompt: 'Pootsy est un service gratuit pour gérer ses prestations d\'aides-ménagères dans le système Titres-Services.\n Ceux-ci sont accessibles à tout personne résidant en Belgique.',
		booking_flow_sodexo_voucher_count_label: 'Votre réservation nécessitera {voucher_count} titres-services par prestation',
		booking_flow_sodexo_voucher_type_title: 'Quelle sorte de Titres-Services souhaitez-vous utiliser?',
		booking_flow_sodexo_voucher_type_subtitle: 'Sauvez la planète, choisissez les Titres-Services électroniques :)',
		booking_flow_sodexo_voucher_type_electronic: 'Electroniques',
		booking_flow_sodexo_voucher_type_paper: 'Papiers',
		booking_flow_sodexo_region_title: 'Dans quelle région se trouve votre domicile officiel?',
		booking_flow_sodexo_region_subtitle: 'Il doit s\'agir de votre domicile officiel, celui sur votre carte d\'identité (pas nécessairement celui où aura lieu la prestation).',
		sodexo_region_brussels: 'Bruxelles',
		sodexo_region_flanders: 'Flandres',
		sodexo_region_wallonia: 'Wallonie',
		booking_flow_sodexo_number_title: 'Quel est votre numéro Sodexo?',
		booking_flow_sodexo_number_subtitle: 'Ce numéro est composé de 12 chiffres. Vous pouvez le retrouver dans votre compte Sodexo.',
		booking_flow_sodexo_number_placeholder: 'Ex: 9700000012345',
		booking_flow_sodexo_explainer_title: 'Pas de problème! Pootsy peut se charger de votre inscription avec quelques questions additionnelles!',
		booking_flow_sodexo_explainer_subtitle: 'Savez-vous que les Titres-Services sont un moyen de paiement pratique pour des prestations abordables d\'aides-ménagères à domicile? Ils sont déductibles de vos impôts et vous donnent accès à un large réseau de prestataires locaux pour un prix transparent de 9€ / heure.',
		booking_flow_sodexo_explainer_subtitle_link: 'En savoir plus sur les Titres-Services',
		booking_flow_sodexo_niss_title: 'Quel est votre numéro de Registre National?',
		booking_flow_sodexo_niss_subtitle: 'Ce numéro est composé de 11 chiffres. Vous pouvez le retrouver au dos de votre carte d\'identité.',
		booking_flow_sodexo_niss_placeholder: 'ex: 86.02.18-134.05',
		booking_flow_sodexo_residence_title: 'Quelle est l\'adresse de votre domicile officiel?',
		booking_flow_sodexo_residence_subtitle: 'Il doit s\'agir de votre domicile officiel, celui sur votre carte d\'identité (pas nécessairement celui où aura lieu la prestation).',
		booking_flow_sodexo_residence_choose_new: 'Choisir une nouvelle adresse',
		booking_flow_sodexo_residence_new_modal_title: 'Ajouter une nouvelle adresse',
		booking_flow_sodexo_iban_title: 'Quel est votre numéro de compte en banque?',
		booking_flow_sodexo_iban_subtitle: 'Sodexo a besoin de votre numéro de compte IBAN en cas de remboursement. Cette information n\'est pas enregistrée ni par Pootsy ni par ses partenaires.',
		booking_flow_sodexo_terms_label: 'Je m\'engage à respecter les conditions d\'utilisation du dispositif (A.R. du 12/12/2001 concernant les titres-services).',
		booking_flow_confirmation_title: 'Résumé',
		booking_flow_confirmation_date: 'Date',
		booking_flow_confirmation_time_slot: 'Heure',
		booking_flow_confirmation_time_slot_value: 'De {start}h à {end}h ({duration} heures)',
		booking_flow_confirmation_frequency: 'Fréquence',
		booking_flow_confirmation_price: 'Prix',
		booking_flow_confirmation_price_value: '{price}€ ({voucher_count} titres-services)',
		booking_flow_confirmation_voucher_type: 'Type de Titres-Services',
		booking_flow_confirmation_address: 'Adresse de la prestation',
		booking_confirmation_convention_title: 'Votre Société de Titres-Services sera',
		booking_confirmation_convention_decription: 'Cette société fournit des services de haute qualité qui sont résumés dans leur "Convention Client"',
		booking_confirmation_download_convention: 'Convention client',
		accept_cgu: 'Je suis d\'accord avec les Conditions Générales de Pootsy',
		accept_convention: 'Je suis d\'accord avec la Convention Client de ma société de Titres-Services',
		manage_your_booking_with_the_app: "Gérez votre réservation avec l'App Pootsy",
		manage_your_booking_with_the_app_desc: "Avec l'App Pootsy, vous pouvez gérer vos prestations d'aide-ménagère dans un environnement 100% sécurisé: communiquez avec votre aide-ménagère, modifier vos dates, notez les prestations, recevez des notifications,... Disponible sur iOS et Android.",
		affiliate_page_bio: "Lorem ipsum dolor sit amet, postea fierent et pri, vel integre corrumpit intellegebat ut. Enim expetenda eloquentiam ut eum. Sed ad partem ocurreret conclusionemque, ad eripuit omittam mei. Erant laboramus eos in. Duo dicat omnes ut, an aeque discere duo. Vis in agam salutandi molestiae, probatus persequeris ea pri, usu dicam diceret intellegam ne. Sonet necessitatibus te eam.",
		book_your_service_button: "Réserver une prestation",
		phone: "Téléphone",
		email: "E-mail",
		time_slot_label_top_rating: 'Très appréciée de ses clients!',
		time_slot_label_top_affiliate_rating: 'Partenaire très bien noté!',
		time_slot_label_neighbourhood: 'Habite dans votre voisinage',
		time_slot_label_recent_booking: 'Récemment réservée',
		time_slot_label_friend: 'Recommandée par un ami',
		time_slot_label_language: 'Parle votre langue',
		signup_prompt: "Déjà membre?",
		sign_in: "Cliquez ici pour vous connecter",
		passwords_dont_match: "Vos mots de passe ne correspondent pas.",
		password_confirmation_input_placeholder: "ex: *******",
		accept_emails: "Oui, je veux recevoir la newsletter Pootsy pour recevoir des promotions, des conseils et des nouveautés.",
		logout: "Se déconnecter",
		website_title: 'Pootsy - Trouvez une aide-ménagère pour toutes vos tâches à domicile',
		email_placeholder: 'Ex: jean.michel@pootsy.be',
		signup_header: 'Bienvenue chez Pootsy',
		delete_residence_title: "Supprimer cette adresse?",
		old_password_input_label: "Ancien mot de passe",
		new_password_input_label: "Nouveau mot de passe",
		new_password_confirmation_input_label: "Confirmez votre nouveau mot de passe",
		common_confirm: "Confirmer",
		affiliate_chat_prompt: "Ecrivez ici pour envoyer un message à votre Société de Titres-Services (ex: un problème avec votre aide-ménagère,etc...)",
		welcome: "Bienvenue",
		needs: "Besoins",
		availabilities: "Disponibilités",
		informations: "Informations",
		confirmation: "Confirmation",
		signin_header: "Connectez-vous à votre compte",
		signin_prompt: "Pas encore membre?",
		booking_flow_sign_up: "Cliquez ici pour créer votre compte",
		booking_flow_sign_in: "Cliquez ici pour vous connecter",
		signup_explanation_prompt: "Grâce à Pootsy, vous pouvez:",
		booking_flow_needs_estimation_title: "Nombre d'heures estimées pour votre prestation:",
		booking_flow_needs_estimation_description: "Vous pourrez sélectionner vous même le nombre d’heures que vous souhaitez à l’étape suivante",
		discover_pootsy: "Découvrez Pootsy",
		common_street_box: "Boite",
		service_vouchers_guide_url: "https://pootsy.be/1800/les-titres-services-mode-demploi/?lang=fr",
		enter_zip_code_not_covered_modal_title: "Oups",
		enter_zip_code_not_covered_modal_description: "Cette commune n'est pas encore couverte par Pootsy. Voulez-vous être averti quand ce sera le cas? Laissez nous votre adresse e-mail pour être le premier informé!",
		send: "Envoyer",
		video_url: "https://www.youtube.com/embed/QZM1aNYUH0Q?cc_load_policy=1&cc_lang_pref=fr",
		signup: "Créer mon compte",
		'service_delivery.assigned_event_title': 'La prestation est assignée',
    	'service_delivery.cancelled_event_title':'La prestation est annulée',
    	'service_delivery.ongoing_event_title': 'La prestation a commencé',
    	'service_delivery.finished_event_title': 'La prestation est terminée',
    	'service_delivery.problem_event_title': 'Un problème est survenu durant la prestation',
    	'service_delivery.not_delivered_event_title': 'La prestation n\'a pas pu avoir lieu',
    	'service_delivery.review_event_title': 'Feedback sur la prestation',
   	 	'service_delivery.message_event_title': 'Message',
    	'forgot_password_prompt': 'Mot de passe oublié ou perdu? Donnez-nous votre adresse e-mail et nous vous enverrons les instructions pour le réinitialiser.',
    	'send_recovery_email_button': 'Envoyer',
    	'closed': 'Fermé',
    	'itinerary': 'Itinéraire',
    	"download_app_prompt": "Pour une meilleure expérience, veuillez télécharger l'App Mobile Pootsy, disponible sur iOS et Android",
    	"click_here_to_download_app": "Cliquez ici pour télécharger l'App",
		meta_description: "Pootsy vous aide à réserver une prestation d’aide-ménagère ou de femme de ménage à domicile avec les Titres-Services",
		rating: "",
		website: "Site web",
		tss_empty_modal_title: "Oups",
		tss_empty_modal_description: "Nous n'avons plus de disponibilités dans cette zone. Voulez-vous être averti quand ce sera le cas? Laissez nous votre adresse e-mail pour être le premier informé!",
		review_rating_message: 'Notation',
		pootsy_covers_area_desc: "Découvrez notre réseau de sociétés de Titres-Services agréées par Sodexo. Leurs travailleurs sont tous des professionnels qui sont régulièrement formés pour vous livrer des prestations de ménage impeccables. Avec Pootsy, voyez leurs disponibilités instantanément!",
		pootsy_does_not_cover_area_desc: "Donnez-nous votre adresse e-mail (promis, nous ne l'utiliserons pour rien d'autre!), et nous vous préviendrons dès que Pootsy sera présent dans votre zone.",
		find_my_cleaner_in_area: "Trouver une aide-ménagère à",
		more_about_pootsy: "En savoir plus sur Pootsy",
		more_about_service_vouchers: "En savoir plus sur les Titres-Services",
		pootsy_covers_area_at: "Pootsy est disponible à",
		pootsy_does_not_cover_area_at: "Oh non! Pootsy n'est pas encore disponible à",
		discover_our_partners_in: "Découvrez nos partenaires à",
		see_our_availabilities: "Voir nos disponibilités",
		thank_you_email_sent_flash: "E-mail envoyé, merci!",
		rated: "noté {note} / {total} sur base {total_formatted} avis.",
		affiliate_meta_description: 'Réservez une aide-ménagère chez {affiliateName} en 5 étapes !',
		zip_code_mode_page_title: 'Femmes de ménage et aide-ménagères de confiance à {area} {zoneName}',
		zip_code_mode_meta_description: 'Besoin d\'aide pour votre ménage à {area} {zoneName} ? Faites confiance aux aides-ménagères et femmes de ménage de nos partenaires Titres-Services',
		privacy_action_remove_affiliate_data_title: 'Suppression Contrat Prestataire et effacement des données',
		privacy_action_ask_affiliate_data_description: 'Cette action enverra un message à votre Prestataire de Services pour lui faire savoir que vous souhaitez mettre fin à votre relation contractuelle et effacer vos données personnelles en accord avec sa politique de protection des données.',
		privacy_action_ask_affiliate_data_button_title: 'Supprimer mon contrat',
		privacy_action_remove_pootsy_data_title: 'Suppression compte Pootsy',
		privacy_action_remove_pootsy_data_description: 'Cette action supprimera votre compte Pootsy et vos données personnelles liées endéans les 24 heures. Si vous possédez des contrats actifs avec des Prestataires de Services, ceux-ci ne seront pas impactés.',
		privacy_action_remove_pootsy_data_button_title: 'Supprimer mon compte Pootsy',
		privacy_action_end_contract_title: 'Fin du Contrat Prestataire',
		privacy_action_end_contract_description: 'Cette action mettra fin à votre contrat actuel avec votre Prestataire de Service dès que possible suivant les modalités de votre contrat.',
		privacy_action_end_contract_button_title: 'Mettre fin à mon contrat',
		privacy_action_export_affiliate_data_title: 'Export des données Prestataires',
		privacy_action_ask_export_affiliate_data_description: 'Votre Prestataire de Services récolte certaines données vous concernant dans le cadre de votre relation contractuelle. Vous pouvez exporter ces données pour votre propre référence ou pour les transférer dans un autre outil.',
		privacy_action_ask_export_affiliate_data_button_title: 'Exporter mes données',
		privacy_action_export_pootsy_data_title: 'Export des données Pootsy',
		privacy_action_export_pootsy_data_description: 'Pootsy récolte des données pour faire fonctionner cette App. Vous pouvez exporter ces données pour votre propre référence ou pour les transférer dans un autre outil.',
		privacy_action_export_pootsy_data_button_title: 'Exporter mes données',
		execute_privacy_action_confirmation_title: 'Confirmation',
		account_privacy_terms_title: 'Lisez notre',
		privacy_terms_description: 'Politique de Confidentialité',
		cookie_banner_text: 'Nous utilisons des cookies pour personnaliser le contenu, proposer des fonctionnalités et analyser notre trafic. Vous acceptez ces cookies en utilisant Pootsy. Veuillez lire notre Politque de Confidentialité pour plus d\'information.',
		accept_cookie_policy_button: 'OK',
		cookie_policy_information_button: 'Lire la Politique de Confidentialité',
		commercial_pootsy_email:'Par e-mail',
		commercial_pootsy_push:'Par notification',
		affiliate_commercial_notifications_description:'Acceptez-vous de recevoir des informations commerciale de la part de votre Prestataire de services?',
		communication_email:'Par e-mail',
		communication_push:'Par notification',
		pootsy_commercial_notifications_description: 'Comment voulez-vous recevoir les promotions, conseils et autres informations de Pootsy?',
		communication_notifications_description: 'Comment voulez-vous recevoir les messages de votre aide-ménagère ou de votre prestataire?',
		click_here:'Cliquez ici',
		account_privacy_notifications_title: 'Mes notifications',
		privacy: 'Ma vie privée ',
		commercial_affiliate: 'Oui, j\'accepte',
	},
	nl: {
		become_partner: 'Word partner',
		blog: 'Blog',
		customer_hero_header: "Reserveer een huishoudelijke hulp van topkwaliteit voor al je huishouddiensten",
		customer_hero_prompt: "De eenvoudigste manier om huishouddiensten te reserveren en te beheren. Slecht 9€/uur met dienstencheques (na de belanstingkorting: 7,65€ in het Brussels Gewest en 6,30€ in Vlaanderen)",
		customer_find_cleaner: "Vind nu je huishoudelijke hulp",
		choose_time: "Kies een tijdstip",
		choose_time_desc: "Bekijk alle beschikbaarheden van de huishoudelijke hulpen in je buurt en duid je voorkeur aan voor het tijdstip en de frequentie",
		book_instantly: "Reserveer meteen",
		book_instantly_desc: "Reserveer een huishoudelijke hulp van een plaatselijke dienstencheque-partner met onmiddellijke bevestiging",
		follow_service: "Volg je diensten op",
		follow_service_desc: "Een professionele, opgeleide huishoudelijke hulp zal de prestatie uitvoeren. Deze prestatie kan jij volgen en beheren met de App.",
		affiliate_hero_header: 'Laat je huishoudbedrijf eindelijk digitaliseren',
		affiliate_hero_prompt: 'Beheer je uurroosters, reservaties en Werknemers in real-time met behulp van één interface',
		ask_for_affiliate_demo: 'Vraag een demo aan',
		see_video: 'Hoe werkt Pootsy?',
		im_a_customer: "Ik ben een klant",
		booking_flow_first_step_header: 'De eerste stap\nvoor een netter huis',
		booking_flow_first_step_input_prompt: 'Voeg je straatnaam en -nummer in',
		booking_flow_second_step_header: 'Laten we samen je behoeften nagaan',
		booking_flow_second_step_input_prompt: 'Geen paniek. Wij helpen je bij het berekenen hoeveel uren nodig zijn voor de gevraagde prestatie.',
		address_input_placeholder: 'Voorbeeld: Grote Markt 10, 1000 Brussel',
		next_step: 'Volgende',
		previous: 'Vorige',
		pootsy_benefit_one: 'Betalen met dienstencheques: goedkoop, eenvoudig en duidelijk',
		pootsy_benefit_two: 'Professionele huishoudelijke hulpen van plaatselijke doorgelichte bedrijven',
		pootsy_benefit_three: 'Fiscale korting met het dienstenchequessysteem',
		spinner_message_checking_zip_code: 'Beschikbaarheden nagaan',
		why_use_pootsy: 'Waarom Pootsy gebruiken?',
		quick_n_easy: 'Eenvoudig en snel',
		quick_n_easy_desc: 'Het is nog nooit zo eenvoudig geweest om een huishoudprestatie te reserveren! Reserveer je huishouddienst in twee minuten met onmiddellijke bevestiging. Pootsy is beschikbaar 24/7.',
		affordable: 'Goedkoop',
		affordable_desc: 'Geen bijkomende kosten op Pootsy! Pootsy maakt gebruikt van het dienstenchequessysteem (9€/uur). En het goede nieuws is... Het is fiscaal aftrekbaar ;-).',
		manage_your_devices: 'Beheer je prestaties',
		manage_your_devices_desc: "Pootsy houdt je op de hoogte van de status van je prestaties. Maar er is nog meer! Wens je een tijdstip te wijzigen? Moet je een prestatie annuleren? Geen probleem, dat kan allemaal bij Pootsy!",
		professionals_only: 'Alleen professionelen',
		professionals_only_desc: 'Pootsy werkt met een netwerk van partners over heel België. Alle partners hebben het dienstenchequessysteem geïntegreerd. Dit betekent dat alle huishoudelijke hulpen betrouwbaar en opgeleid zijn.',
		download_app: "De App downloaden",
		asap: "Dat kan in slecht één klik",
		whats_up: "What's up ?",
		service_vouchers: "Dienstencheques",
		they_trust_us: 'Zij vertrouwen ons',
		keep_up: 'Blijf in contact',
		keep_up_prompt: 'Volg het Pootsy-nieuws en blijf op de hoogte van toekomstige events...',
		pootsy_pro: 'Pootsy pro',
		cgu: 'Algemene voorwaarden',
		press: 'Pers',
		contact_us: 'Contact',
		how_does_it_work: 'Hoe werkt het?',
		how_does_it_work_desc: 'De dienstencheques worden gesubsidieerd door de Belgische Gewesten (Brussel, Vlaanderen, Wallonië). Elke meerderjarige persoon die in België woont kan deze gebruiken om poets-, strijk- en transportprestaties te reserveren, voor een betaalbare prijs. Door Pootsy en de dienstencheques te gebruiken heb je de mogelijkheid om huishoudprestaties te reserveren voor slechts 9€/uur, waarvan een deel fiscaal aftrekbaar is.',
		discover_customer_guide: 'Ontdek onze "Dienstencheques-gids"',
		they_tested_pootsy: "Zij gebruiken Pootsy:",
		more_articles: 'Meer artikels van onze blog',
		better_agency_management: 'Een web-interface om je bedrijf te beheren',
		webapp: 'Beheer je bedrijf',
		planning_management: 'Beheer je planning',
		planning_management_desc: "Dynamisch en real-time beheer van de planning en prestaties van je Werknemers. De agenda's worden automatisch gevuld: laat je staff zich concentreren op wat echt belangrijk is!",
		follow_your_team: 'Volg je team op in real-time!',
		follow_your_team_desc: "Wees op de hoogte van wat er gebeurt. Indien een probleem voorkomt, krijg je een bericht en kan je meteen communiceren met de klanten en de Werknemers.",
		accessible_everywhere: 'Altijd en overal beschikbaar',
		accessible_everywhere_desc: 'Je interface is in de cloud! Dat betekent dat je van elke computer toegang kan krijgen tot je planning, je sociaal secretariaat - exports en je sodexo-documenten, waar je ook bent.',
		pcla_real_time_access: "Real-time toegang hebben tot de planning en uurroosters (beschikbaarheden, verlof,...) van de werknemers",
		pcla_updated_statuses: "Uw Werknemers actualiseren de status van hun prestaties en rapporteren problemen",
		pcla_communication_system: "Digitaal communicatiesysteem met tussen bedrijf en klanten",
		pcla_auto_encode_services: "Diensten betaald met elektronische cheques worden automatisch ingevoerd",
		pcla_psv_scanner: "Papieren dienstencheques kunnen rechtstreeks met de app gescand worden",
		pcla_ios_android: "Beschikbaar op iOS en Android",
		mobile_app: "Voor je Werknemers",
		help_your_employees: "Een mobiele App voor je huishoudelijke hulpen",
		select_employee_count: "Hoeveel huishoudelijke hulpen werken in je bedrijf?",
		visibility: "Voor je klanten",
		an_app_and_website_for_your_customers: "Een app en een website voor je klanten",
		exposure_automatic_calendar_updates: "De kalender wordt automatisch gevuld wanneer klanten hun prestaties reserveren",
		exposure_dedicated_webpage: "Een webpagina toegewijd aan je bedrijf geeft de mogelijkheid aan je klanten om je bedrijf eenvoudig terug te vinden en zorgt voor de beste zoekresultaten.",
		exposure_customer_communication: "Hou contact met je klanten met de in-app chat",
		exposure_real_time_service_monitoring: "Real-time prestatiebeheer",
		exposure_available_on_ios_android: "Beschikbaar op iOS en Android",
		pricing_tip: "Tip: Ook al kiezen de meeste bedrijven ervoor om al hun Werknemers in Pootsy te intergreren, heb je de mogelijkheid om slechts enkele van je Werknemers in het systeem in te brengen (bv. diegene die hun planning moeten vullen) en later upgraden",
		no_hidden_fees: "Geen verborgen kosten, geen verbintenis",
		employees: 'Werknemers',
		pro_summary_hr_management: "Beheer je Werknemers, hun planning en je klanten",
		pro_summary_real_time_control: "Real-time controle van de activiteit van je Werknemers",
		pro_summary_simple_communication: "Eenvoudige communicatie met je klanten",
		pro_summary_acquisition_channel: "Aanwinstkanaal van nieuwe klanten",
		pro_summary_secsoc_sodexo_integrations: "Integratie van je sociaal secretariaat en Sodexo",
		pro_summary_easy_to_use: "Eenvoudig gebruik, geen installatie nodig",
		discover_customer_app: "Ontdek de app voor de klanten",
		in_summary: "In een notendop",
		in_summary_desc: "Waarom Pootsy gebruiken?",
		booking_flow_bedrooms: 'Slaapkamers',
		booking_flow_bathrooms: 'Badkamers',
		booking_flow_frequency: 'Frequentie',
		booking_flow_frequency_once: 'Eémalig',
		booking_flow_frequency_every_week: 'Elke week',
		booking_flow_frequency_every_two_weeks: 'Om de twee weken',
		booking_service_fridge: 'Frigo',
		booking_service_cabinets: 'WC\'s',
		booking_service_oven: 'Oven',
		booking_service_windows: 'Ramen',
		booking_service_laundry: 'Was',
		booking_service_ironing: 'Strijken',
		booking_flow_desired_booking_services: 'Gewenste diensten',
		booking_flow_additional_options: 'Bijkomende opties',
		booking_flow_worker_language_undefined: 'Maakt niet uit',
		booking_flow_affiliate_undefined: 'Maakt niet uit',
		booking_flow_worker_undefined: 'Maakt niet uit',
		booking_flow_choose_worker_language: 'Taal van de werknemer',
		booking_flow_choose_affiliate: 'Ik ken een dienstverlener',
		booking_flow_choose_worker: 'Ik ken een werknemer',
		booking_flow_i_know_a_worker: 'Ik ken het Sodexo-nummer van de huishoudelijke hulp',
		booking_flow_worker_sodexo_number_placeholder: 'Voer zijn/haar Sodexo-nummer hier in',
		spinner_message_fetching_worker_languages: 'Vind Werknemers terug',
		spinner_message_fetching_affiliates: 'Vind partners terug',
		spinner_message_checking_worker_sodexo_number: 'Check het Sodexo-nummer van de klant',
		error_wrong_worker_sodexo_number: 'Dit Sodexo-nummer hoort bij geen enkele huishoudelijke hulp',
		booking_flow_choose_affiliate_info: 'Je kent reeds een dienstverlener in jou buurt en je wenst met hem te werken? Geen probleem! Dit is een lijst van dienstverleners in je buurt, kies je favoriet!',
		booking_flow_choose_worker_info: 'Ken je reeds een huishoudelijke hulp en wens je met hem/haar verder te werken? Geen probleem. Vraag zijn/haar Sodexo-nummer en bekijk de beschikbaarheden!',
		booking_flow_i_know_a_worker_info: 'Wens je verder te werken met een huishoudelijke hulp die je al kent? Kies in de onderstaande lijst.',
		booking_flow_third_step_header: 'Kies het tijdstip van je eerste prestatie',
		booking_flow_date_selection_title_first_part: 'Duur van uw prestatie:',
		booking_flow_date_selection_title_second_part: 'Locatie van de prestatie:',
		booking_flow_date_selection_subtitle: 'Je reservatie zal met {voucher_count} dienstencheques worden betaald voor elk voorkomen',
		common_hours: 'uren',
		booking_flow_date_selection_worker_label: 'Jouw huishoudelijke hulp is {worker_name}',
		time_slot_seeker_choose_hour: 'Kies je favoriet tijdstip voor je prestatie',
		booking_flow_date_selection_choose_another_worker: 'Kies een andere huishoudelijke hulp',
		booking_flow_date_selection_worker_selection_title: 'Kies een huishoudelijke hulp voor één van onze partners',
		booking_flow_date_selection_worker_selection_sub_title: 'Al onze partners zijn Sodexo-gecertificeerd and hun Werknemers zijn professioneel',
		booking_flow_date_selection_worker_selection_recommended: 'Aangeraden door Pootsy',
		booking_flow_date_selection_worker_selection_select: 'Kies mij!',
		booking_flow_date_selection_worker_selection_selected: 'Geselecteerd',
		booking_flow_residence_selection_title: 'Waar zal de prestatie\ntplaatsvinden',
		booking_flow_residence_selection_new_residence_title: 'Een nieuw adres toevoegen?',
		booking_flow_residence_selection_use_address: 'Gebruik dit adres',
		booking_flow_housing_type: 'Woningtype',
		common_housing_type_house: 'Huis',
		common_housing_type_apartment: 'Appartement',
		common_housing_type_other: 'Ander(e)',
		common_street_name: 'Straat',
		common_street_number: 'Nummer',
		common_zip_code: 'Postcode',
		common_city: 'Stad',
		common_surface: 'Oppervlakte',
		common_other_info: 'Andere informatie',
		common_how_to_get_in: 'Hoe kom ik binnen ?',
		bookings: 'Prestaties',
		date: "Datum",
		time: "Tijd",
		recurrence: "Frequentie",
		common_m2: 'm²',
		common_i_have_a_pet: 'Ik heb een huisdier',
		advantages: "Voordelen",
		testimony2: "\"We hebben Kamila via Pootsy gevonden. Zij werkt voor een dienstenchequesbedrijf in onze buurt. We konden haar onmiddellijk vertrouwen en ze komt nu elke week werken!\"",
		testimony1: "\"Het was soms zeer ingewikkeld om de dienstenchequesbedrijf van onze vorige huishoudelijke hulpen te contacteren. Dankzij Pootsy kunnen we hen nu rechtstreeks berichten sturen en helpen ze ons in geval van problemen\"",
		testimony4: "\"Het is zeer handig om de status van onze diensten op te volgen. Onze huishoudster stuurt ons een foto van een leeg huishoudproduct dat wij moeten kopen voor een volgende dienst. Het is zeer handig!\"",
		testimony3: "\"Ik ben een grote fan van nieuwe technologieën en was dus aangenaam verrast toen ik een dienst in minder dan twee minuten via mijn GSM kon reserveren. Ik ken het dienstenchequessyteem niet maar Pootsy zorgde voor de inscrhijving. Het was heel gemakkelijk!\"",
		testimony2_name: "Martine",
		testimony2_location: "Ukkel",
		testimony1_name: "Maximilien",
		testimony1_location: "Antwerpen",
		testimony3_name: "Alexandra",
		testimony3_location: "Waterloo",
		testimony4_name: "Sarah & Tom",
		testimony4_location: "Brussel",
		testimonies: "Getuigenissen",
		price_per_month: ".99€/ maand",
		always_accessible: "Een web interface om je bedrijf te beheren",
		always_accessible_desc: "Beheer je planning op een eenvoudige manier, download rapporten en officiële documenten en communiceer met je werknemers en je klanten",
		easy_to_use: "Een mobiele App & website voor je klanten",
		easy_to_use_desc: "Je klanten verkrijgen updates over hun prestaties, je kan je Werknemers onmiddellijk reserveren en er gemakkelijk mee communiceren.",
		communication_tool: "Een mobiele App for je Werknemers",
		communication_tool_desc: "Je Werknemers krijgen hun planning in real-time, ze geven een feedback over hun prestaties en vragen verlof aan",
		login: "Log in",
		my_affiliate: "Mijn dienstverlener",
		my_affiliates: "Mijn dienstverlener",
		my_account: "Mijn account",
		my_services: "Mijn prestaties",
		future_bookings: "Toekomst",
		past_bookings: "Verleden",
		to: "van",
		from: "tot",
		assigned: "Toegewezen",
		finished: "Beëindigd",
		finished_without_confirmation: "Beëindigd",
		ongoing: "Lopend",
		cancelled: "Geannuleerd",
		problem: "Probleem",
		not_delivered: "Niet uitgevoerd",
		address: "Adres",
		service_for_date: "Prestatie op",
		problem_with_service_prompt: "Heb je een probleem met je prestatie of je huishoudster?",
		feel_like_leaving_a_message: "Laat hier een bericht achter voor je huishoudelijke hulp",
		what_did_you_think_of_last_service: "Wat denk je van de laatste prestatie?",
		share_on_facebook: "Deel op facebook",
		share_on_twitter: "Deel op Twitter",
		share_with_email: "Deel via email",
		new_booking: "Nieuwe reservatie",
		do_you_like_pootsy: "Gebruikt u graag Pootsy?",
		share_pootsy_with_friends: "Deel Pootsy met je vrienden",
		once: "Eénmalig",
		every_week: "Wekelijks",
		every_two_weeks: "Tweewekelijks",
		review_modal_title: "Wat denk je van je laatste prestatie?",
		leave_a_message_optional: "Laat een bericht achter (facultatief)",
		continue: "Ga verder",
		cancel: "Annuleer",
		what_did_you_think_of_this_service: "Wat denk je van deze prestatie?",
		service_happened_at_date: "De prestatie vond plaats op",
		service_delivered_by: "met",
		show_more: '+ Toon meer prestaties',
		twitter_sharing_message: "Hulp nodig thuis met je dagelijkse klusjes? Ontdek Pootsy op https://www.pootsy.be!",
		mail_sharing_message: "Hulp nodig thuis met je dagelijkse klusjes? Ontdek Pootsy op https://www.pootsy.be!",
		login_header: "Welkom bij Pootsy",
		create_account_prompt: "Nog geen account?",
		create_account: "Klik hier om je eigen account aan te maken",
		email_input_label: "Voer je e-mailadres in",
		email_input_placeholder: "vb.: jan.metdepet@pootsy.be",
		forgot_password: "Paswoord vergeten?",
		password_input_label: "Voer je paswoord in",
		password_input_placeholder: "vb: ********",
		remember_me: "Herinner mij",
		residence_type: 'Woningtype',
		surface: 'Oppervlakte',
		pets: "Huisdieren",
		yes: "Ja",
		no: "Nee",
		house: 'Huis',
		apartment: 'Appartement',
		type_other: 'Ander(e)',
		profile: "Mijn profiel",
		addresses: "Mijn adressen",
		notifications: "Mijn meldingen",
		security: "Mijn beveiligingsinstellingen",
		account_profile_prompt: "Persoonlijke informatie",
		gender: "Geslacht",
		gender_mr: "Mr",
		gender_mrs: "Mevr",
		first_name_input_label: "Voornaam",
		last_name_input_label: "Familienaam",
		language: "Taal",
		language_fr: "Français",
		language_nl: "Nederlands",
		language_en: "English",
		account_profile_contact_prompt: "Contact informatie",
		telephone_input_label: "GSM-nummer",
		secondary_phone_input_label: "Tweede telefoonnummer",
		landline_phone_input_label: "Vaste lijn",
		account_profile_sodexo_prompt: "Sodexo-informatie",
		sodexo_reference_input_label: "Uw Sodexo-nummer",
		sodexo_region: "Uw Sodexo-regio",
		sodexo_region_bxl: "Brussel",
		sodexo_region_vl: "Vlaanderen",
		sodexo_region_wal: "Wallonië",
		save: "Opslaan",
		terms_of_service: "Algemene voorwaarden",
		ask_for_demo_mail_subject: "Ik wens een demo van Pootsy te verkijgen",
		ask_for_demo_mail_content: "Hallo,\nik ontvang graag een demo van Pootsy Pro om al de voordelen voor mijn dienstenchequesbedrijf te ontdekken.\n Dit zijn mijn contactgegevens:\n",
		dismiss_error_modal: "OK",
		error_modal_title: "Fout",
		booking_flow_sodexo_title: 'Ben je ingeschreven\nvoor de dienstencheques van Sodexo?',
		booking_flow_sodexo_input_prompt: 'Pootsy is een kosteloze dienst die je de mogelijkheid geeft om je prestaties gemakkelijk te beheren dankzij de dienstencheques van Sodexo.\nDeze dienstencheques zijn beschikbaar voor elke inwoner van België.',
		booking_flow_sodexo_voucher_count_label: 'Je hebt {voucher_count} dienstencheques nodig om je prestatie te betalen.',
		booking_flow_sodexo_voucher_type_title: 'Welk type dienstencheques wens je te gebruiken?',
		booking_flow_sodexo_voucher_type_subtitle: 'Wees milieuvriendelijk en kies voor electronische dienstencheques! :-)',
		booking_flow_sodexo_voucher_type_electronic: 'Electronische dienstencheques',
		booking_flow_sodexo_voucher_type_paper: 'Papieren dienstencheques',
		booking_flow_sodexo_region_title: 'In welk gewest bevindt zich je officieel adres?',
		booking_flow_sodexo_region_subtitle: 'Dit moet je officieel adres zijn die ingeschreven staat op je identiteitskaart, niet het adres van de prestatie',
		sodexo_region_brussels: 'Brussel',
		sodexo_region_flanders: 'Vlaanderen',
		sodexo_region_wallonia: 'Wallonië',
		booking_flow_sodexo_number_title: 'Wat is je Sodexo-klantennummer?',
		booking_flow_sodexo_number_subtitle: 'Dit nummer telt 12 cijfers en bevindt zich op je Sodexo-account',
		booking_flow_sodexo_number_placeholder: 'vb.: 9700000012345',
		booking_flow_sodexo_explainer_title: 'Dat is niet erg! We kunnen je het leven gemakkelijker maken en de inschrijving voor jou maken.',
		booking_flow_sodexo_explainer_subtitle: 'Wist je dat de dienstencheques het meest voordelige betaalmiddel is voor je prestaties? Deze zijn inderdaad fiscaal aftrekbaar en ze geven je toegang tot een netwerk van professionele huishoudelijke hulpen voor slechts 9€/uur.',
		booking_flow_sodexo_explainer_subtitle_link: 'Meer weten over Sodexo?',
		booking_flow_sodexo_niss_title: 'Wat is je Rijksregisternummer?',
		booking_flow_sodexo_niss_subtitle: 'Dit nummer bevat 13 cijfers en is terug te vinden op je identiteitskaart',
		booking_flow_sodexo_niss_placeholder: '86.02.18-304.27',
		booking_flow_sodexo_residence_title: 'Wat is je officiële adres?',
		booking_flow_sodexo_residence_subtitle: 'Dit betreft het adres dat werd ingeschreven op je identiteitskaart.',
		booking_flow_sodexo_residence_choose_new: 'Een nieuw adres kiezen',
		booking_flow_sodexo_residence_new_modal_title: 'Een nieuw adres toevoegen',
		booking_flow_sodexo_iban_title: 'Wat is je bankrekeningnummer?',
		booking_flow_sodexo_iban_subtitle: 'Sodexo heeft je IBAN-rekeningnummer nodig in geval van terugbetaling. Deze gegevens zullen nog bewaard nog gebruikt worden door Pootsy en partners.',
		booking_flow_sodexo_terms_label: 'Ik accepteer de algemene gebruiksvoorwaarden van het dienstenchequessysteem (Koninklijk Besluit van 12/12/2001)',
		booking_flow_confirmation_title: 'Samenvatting',
		booking_flow_confirmation_date: 'Datum',
		booking_flow_confirmation_time_slot: 'Tijd',
		booking_flow_confirmation_time_slot_value: 'Van {start}u tot {end}u ({duration} uren)',
		booking_flow_confirmation_frequency: 'Frequentie',
		booking_flow_confirmation_price: 'Prijs',
		booking_flow_confirmation_price_value: '{price}€ ({voucher_count} dienstencheques)',
		booking_flow_confirmation_voucher_type: 'Type cheques',
		booking_flow_confirmation_address: 'Adres van de prestatie',
		booking_confirmation_convention_title: 'Uw dienstverlener is:',
		booking_confirmation_convention_decription: 'Deze partner verleent prestaties van topkwaliteit die opgenomen zijn in de klantenovereenkomst.',
		booking_confirmation_download_convention: 'Klantenovereenkomst',
		accept_cgu: 'Ik ga akkoord met de Algemene Voorwaarden van Pootsy',
		accept_convention: 'Ik ga akkoord met de Klantenovereenkomst van de Dienstverlener',
		manage_your_booking_with_the_app: "Beheer je reservatie met de Pootsy App",
		manage_your_booking_with_the_app_desc: "Met Pootsy kan je je huishouddiensten beheren op een 100% veilig platform: communiceer met je Werknemers, wijzig een datum, evalueer een dienst, krijg meldingen... Beschikbaar op iOS en Android",
		affiliate_page_bio: "Lorem ipsum dolor sit amet, postea fierent et pri, vel integre corrumpit intellegebat ut. Enim expetenda eloquentiam ut eum. Sed ad partem ocurreret conclusionemque, ad eripuit omittam mei. Erant laboramus eos in. Duo dicat omnes ut, an aeque discere duo. Vis in agam salutandi molestiae, probatus persequeris ea pri, usu dicam diceret intellegam ne. Sonet necessitatibus te eam.",
		book_your_service_button: "Reserveer een prestatie",
		phone: "Telefoon",
		email: "Email",
		time_slot_label_top_rating: 'Best beoordeelde huishoudelijke hulp!',
		time_slot_label_top_affiliate_rating: 'Best beoordeelde dienstverlener!',
		time_slot_label_neighbourhood: 'Woont in je buurt',
		time_slot_label_recent_booking: 'Recent gereserveerd',
		time_slot_label_friend: 'Aanbevolen door een vriend',
		time_slot_label_language: 'Spreekt je taal',
		signup_prompt: "Al lid?",
		sign_in: "Klik hier om in te loggen",
		passwords_dont_match: "Je paswoorden komen niet overeen",
		password_confirmation_input_placeholder: "vb: *******",
		accept_emails: "Ja, ik wens de Pootsy-nieuwsbrief te verkrijgen en op de hoogte te blijven van kortingen, tips en updates",
		logout: "Log out",
		website_title: 'Pootsy - Reserveer een huishoudelijke hulp van topkwaliteit',
		email_placeholder: 'Ex: jan.metdepet@pootsy.be',
		signup_header: 'Welkom bij Pootsy',
		delete_residence_title: "Dit adres verwijderen?",
		old_password_input_label: "Vorig wachtwoord",
		new_password_input_label: "Nieuw wachtwoord",
		new_password_confirmation_input_label: "Bevestig nieuw wachtwoord",
		common_confirm: "Bevestigen",
		affiliate_chat_prompt: "Typ hier een bericht voor je dienstenchequebedrijf (ex: een probleem met je huishoudster, enz...)",
		welcome: "Welkom",
		needs: "Behoeften",
		availabilities: "Beschikbaarheden",
		informations: "Gegevens",
		confirmation: "Bevestiging",
		signin_header: "Log in",
		signin_prompt: "Nog geen account?",
		booking_flow_sign_up: "Klik hier om een account aan te maken",
		booking_flow_sign_in: "Klik hier om in te loggen",
		signup_explanation_prompt: "Voordelen van Pootsy:",
		booking_flow_needs_estimation_title: "Aangeraden aantal uren voor je dienst:",
		booking_flow_needs_estimation_description: "Je kan het definitieve aantal uren op het volgende scherm kiezen",
		discover_pootsy: "Ontdek Pootsy",
		common_street_box: "Bus",
		service_vouchers_guide_url: "https://pootsy.be/3768/dienstencheques-hoe-werkt-het/?lang=nl",
		enter_zip_code_not_covered_modal_title: "Oeps",
		enter_zip_code_not_covered_modal_description: "Wij zijn nog niet aanwezig in dit gebied. Laat ons uw emailadres achter en we houden u op de hoogte van onze groei! :-)",
		send: "Verzenden",
		video_url: "https://www.youtube.com/embed/Tq5r5Fcpj1o?cc_load_policy=1&cc_lang_pref=nl",
		signup: "Mijn account aanmaken",
		'service_delivery.assigned_event_title': 'De prestatie werd toegewezen',
    	'service_delivery.cancelled_event_title':'De prestatie werd geannuleerd',
    	'service_delivery.ongoing_event_title': 'De prestatie is begonnen',
    	'service_delivery.finished_event_title': 'De prestatie werd uitgevoerd',
    	'service_delivery.problem_event_title': 'Er is een fout opgetreden tijdens de prestatie',
    	'service_delivery.not_delivered_event_title': 'De prestatie kon niet uitgevoerd worden',
    	'service_delivery.review_event_title': 'Feedback over de prestatie',
    	'forgot_password_prompt': 'Wachtwoord vergeten? Geef het e-mailadres in waarmee u op Pootsy geregistreerd bent, en we sturen u een link om uw wachtwoord te resetten.',
    	'send_recovery_email_button': 'Sturen',
    	'closed': 'Gesloten',
    	'itinerary': 'Route',
    	"download_app_prompt": "Voor een betere ervaring, gelieve de Pootsy Mobile App te downloaden (beschikbaar op iOS en Android)",
    	"click_here_to_download_app": "Klik hier om Pootsy te downloaden",
		meta_description: "Met Pootsy vindt u onmiddellijk een huishoudelijke hulp of een poetsvrouw met Dienstencheques in uw buurt",
		website: "Website",
		tss_empty_modal_title: "Oeps",
		tss_empty_modal_description: "Wij hebben geen beschikbaarheden in dit gebied meer. Laat ons uw emailadres weten en we houden u op de hoogte van onze groei! :-)",
		review_rating_message: 'Beoordeling',
		pootsy_covers_area_desc: "Ontdek ons netwerk van dienstenchequebedrijven erkend door Sodexo. Hun werknemers zijn allemaal professionals die regelmatig opleidingen volgen om julle vlekkeloze prestaties te leveren. Bekijk hun beschikbaarheden onmiddelijk met Pootsy!",
		pootsy_does_not_cover_area_desc: "Geef ons uw e-mail (beloofd we gebruiken het voor niets anders!), en we verwittigen u zodra Pootsy in uw zone te werk is.",
		find_my_cleaner_in_area: "Vind uw poetshulp in",
		more_about_pootsy: "Meer weten over Pootsy",
		more_about_service_vouchers: "Meer weten over de dienstencheques",
		pootsy_covers_area_at: "Pootsy is beschikbaar in",
		pootsy_does_not_cover_area_at: "Oh nee! Pootsy is niet niet beschikbaar in",
		discover_our_partners_in: "Ontdenk onze partners in",
		see_our_availabilities: "Bekijk onze beschikbaarheden",
		thank_you_email_sent_flash: "E-mail verzonden, bedankt!",
		rated: "beoordeeld {note} / {total} op basis van {total_formatted} beoordelingen.",
		affiliate_meta_description: 'Boek een poetsvrouw bij {affiliateName} in 5 stappen !',
		zip_code_mode_page_title: 'Vertrouwelijke poetsvouw voor uw huishouden in {area} {zoneName}',
		zip_code_mode_meta_description: 'Hulp nodig voor uw huishouden in {area} {zoneName} ? Vertrouw de poetsvrouwen en kuisvrouwen van onze dienstencheques partners in uw buurt',
		privacy_action_remove_affiliate_data_title: 'Verwijder Dienstverlener contract en gegevens',
		privacy_action_ask_affiliate_data_description: 'Deze actie zal een bericht naar jouw dienstverlener sturen om te laten weten dat je jouw contract wil beëindigen en jouw persoonlijke gegevens verwijderen.',
		privacy_action_ask_affiliate_data_button_title: 'Mijn contract verwijderen',
		privacy_action_remove_pootsy_data_title: 'Verwijder Pootsy account',
		privacy_action_remove_pootsy_data_description: 'Deze actie zal jouw Pootsy account en persoonlijke gegevens binnen 24 uren verwijderen. Jouw contract(en) met jouw dienstverlener(s) worden niet betrokken.',
		privacy_action_remove_pootsy_data_button_title: 'Mijn Pootsy account verwijderen',
		privacy_action_end_contract_title: 'Eind Dienstverlener Contract',
		privacy_action_end_contract_description: 'Deze actie zal jouw contract met jouw dienstverlener beëindigen (volgens de modaliteiten van het contract).',
		privacy_action_end_contract_button_title: 'Mijn contract beëindigen',
		privacy_action_export_affiliate_data_title: 'Export Dienstverlener gegevens',
		privacy_action_ask_export_affiliate_data_description: 'Jouw dienstverlener heeft in het kader van jouw contract gegevens over jou verzameld. Je kan deze gegevens exporteren voor jezelf of om in een andere tool te overbrengen.',
		privacy_action_ask_export_affiliate_data_button_title: 'Mijn gegevens exporteren',
		privacy_action_export_pootsy_data_title: 'Export Pootsy gegevens',
		privacy_action_export_pootsy_data_description: 'Pootsy verzamelt gegevens zodat je onze Apps kan gebruiken. Je kan deze gegevens exporteren voor jezelf of om in een andere tool te overbrengen.',
		privacy_action_export_pootsy_data_button_title: 'Mijn gegevens exporteren',
		execute_privacy_action_confirmation_title: 'Bevestiging',
		account_privacy_terms_title: 'Lees ons',
		privacy_terms_description: 'Privacybeleid',
		cookie_banner_text: 'Wij gebruiken cookies om je gebruikerservaring te optimaliseren en om ons traffic te analyseren. Door Pootsy te gebruiken, ga je ermee akkoord dat wij cookies gebruiken. Lees ons privacybeleid voor meer informatie.',
		accept_cookie_policy_button: 'OK',
		cookie_policy_information_button: 'Ons Privacybeleid lezen',
		commercial_pootsy_email:'Door e-mail',
		commercial_pootsy_push:'Door notificatie',
		affiliate_commercial_notifications_description:'Wilt u graag commerciële informatie van uw dienstverlener krijgen?',
		communication_email:'Door e-mail',
		communication_push:'Door notificatie',
		pootsy_commercial_notifications_description: 'Hoe wenst u op de hoogte blijven van promoties, tips & tricks en andere informatie van Pootsy?',
		communication_notifications_description: 'Hoe wenst u de berichten van uw huishoudelijke hulp of uw dienstverlener ontvangen?',
		click_here:'Klik hier',
		account_privacy_notifications_title: 'Mijn notificaties',
		privacy: 'Mijn privacy',
		commercial_affiliate: 'Ja',
	}
}



// WEBPACK FOOTER //
// ./src/translations.js